import type { SourceValue } from '../../sources';
import type { ExcludeFilterParameter } from './dataServiceURL';

export function getDataServiceExcludeContentFilters<T extends SourceValue>(
  sourceValue: T,
  settingAndPostTypePairs: { [K in keyof T]?: string }
): ExcludeFilterParameter[] {
  return Object.entries(settingAndPostTypePairs).reduce<
    ExcludeFilterParameter[]
  >((filters, entry) => {
    const [key, value] = entry!;

    if (!sourceValue[key]) {
      filters.push({
        type: 'exclude',
        post_type: value
      } as ExcludeFilterParameter);
    }

    return filters;
  }, []);
}
